module.exports = __webpack_public_path__ + "static/img/rongyu1.6000009.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyu1.jpg
// module id = HpIp
// module chunks = 1